import React, { useEffect } from 'react';
import queryString from 'query-string';
import { AppState } from 'stores/type';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { Splash } from 'views/components/molecules/Splash';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';

export const SDKDeviceVerificationPage: React.FC = () => {
  const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
  const uriScheme = queryString.parse(location.search)['uri_scheme'] as string;
  const iphoneUid = queryString.parse(location.search)['iphone_uid'] as string;
  const device = useSelector((state) => state.deviceState.device);

  useEffect(() => {
    if (!uriScheme) {
      return;
    }
    const uriSchemeWithPath = `${uriScheme}://identifier`;

    if (device && device.uid) {
      location.replace(`${uriSchemeWithPath}?id=${device.uid}`);
    } else if (iphoneUid) {
      location.replace(`${uriSchemeWithPath}?id=${iphoneUid}`);
    } else {
      location.replace(uriSchemeWithPath);
    }
  }, []);

  return (
    <DefaultTemplate headerText="">
      <Splash />
    </DefaultTemplate>
  );
};
